import React from 'react'
import { RealEstateDataPageComponentData, StatePropertiesSlice } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import { useGetRankingQuery } from '@apis/mediacore/owner'
import { Link } from 'gatsby'
import { useDispatch, useSelector } from 'react-redux'
import useQuerySummary from '@hooks/useQuerySummary'
import { reduxUpdateFilters } from '@slices/propertiesSlice'

const FrequentSearch = (props: RealEstateDataPageComponentData) => {
  const { title, global_data } = props

  const { data, isLoading } = useGetRankingQuery()
  const API_KEY = global_data.pageConfig.keys.tokko

  const { allSummaryData } = useQuerySummary({ API_KEY })

  const dispatch = useDispatch()

  const { filters } = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )!

  const updateFilters = ({
    operation_name,
    type_name,
    location_name,
  }: {
    operation_name?: string
    type_name?: string
    location_name?: string
  }) => {
    const type_find = allSummaryData?.objects.property_types.find(
      (tag: { type: string }) => tag.type === type_name,
    )
    const loc_find = allSummaryData?.objects.locations.find(
      (loc: { location_name: string }) => loc.location_name === location_name,
    )

    return dispatch(
      reduxUpdateFilters({
        ...filters,
        operation: operation_name?.toLowerCase(),
        type: type_find ? [{ name: type_find.type, id: type_find.id }] : [],
        location: loc_find ? [{ name: loc_find.location_name, id: loc_find.location_id }] : [],
      }),
    )
  }

  const valideRepeat = (values: any) => {
    //function que borre los values repetido donde el tipo y la operacion sean iguales
    const filtered: any = []
    for (const iterator of values) {
      const { type, operation } = iterator
      if (
        !filtered.find(
          (filter: { type: string; operation: string }) =>
            filter.type == type && filter.operation == operation,
        )
      ) {
        filtered.push(iterator)
      }
    }
    return filtered
  }

  return (
    !isLoading &&
    data?.length! > 0 && (
      <section
        id="frequentProps"
        className={'fp'}
      >
        <Container fluid>
          <>
            <Row>
              <Col xs={12}>
                <h2 className="section-title pb-lg-5 mb-lg-4 mb-5 text-center">{title}</h2>
              </Col>
            </Row>
            <Row className="text-center container-fluid mx-auto px-0 px-lg-auto">
              {!isLoading ? (
                data?.map(({ label, values }, index) => (
                  <Col
                    key={index}
                    xs={12}
                    lg={3}
                    className="mb-4 mb-lg-0"
                  >
                    <h5 className="mb-lg-4 mb-3 mt-lg-0 mt-4 text-uppercase">
                      PROPIEDADES EN {label}
                    </h5>
                    {index < 2 ? (
                      <>
                        {values?.map(({ type, location }, index) => (
                          <Link
                            key={index}
                            className="d-block text-center prop-link mb-2"
                            to={`${label.toLowerCase()}/${type
                              .replaceAll(' ', '')
                              .toLowerCase()}/${location?.replaceAll(' ', '-').toLowerCase()}`}
                            onMouseEnter={() =>
                              updateFilters({
                                operation_name: label,
                                type_name: type,
                                location_name: location,
                              })
                            }
                          >
                            {type}
                            {type[type.length - 1] == 'l' || type[type.length - 1] == 'r'
                              ? 'es'
                              : 's'}{' '}
                            {'en ' + label} en
                            {' ' + location}
                          </Link>
                        ))}
                      </>
                    ) : (
                      <>
                        {valideRepeat(values)?.map(
                          (
                            { type, operation }: { type: string; operation: string },
                            index: string,
                          ) => (
                            <Link
                              key={index}
                              className="d-block text-center prop-link mb-2"
                              to={`${operation.toLowerCase()}/${type
                                .replaceAll(' ', '')
                                .toLowerCase()}/${label?.replaceAll(' ', '-').toLowerCase()}`}
                              onMouseEnter={() =>
                                updateFilters({
                                  operation_name: operation,
                                  type_name: type,
                                  location_name: label,
                                })
                              }
                            >
                              {type}
                              {type[type.length - 1] == 'l' || type[type.length - 1] == 'r'
                                ? 'es'
                                : 's'}{' '}
                              {'en ' + operation} en
                              {' ' + label}
                            </Link>
                          ),
                        )}
                      </>
                    )}
                  </Col>
                ))
              ) : (
                <p className="load-text">Cargando...</p>
              )}
            </Row>
          </>
        </Container>
      </section>
    )
  )
}

export default FrequentSearch
